import { createTheme } from "@mui/material";

// Material Tracker look for MUI screens (tracker, planner, uploads, reports and its admin area):
// indigo accent, IBM Plex, tight corners. Matches the .pt-app / .pt-admin tokens in App.css and
// keeps the module distinct from NPD.
export const materialTrackerTheme = createTheme({
  palette: {
    primary: { main: "#4338ca", dark: "#3730a3", light: "#6366f1", contrastText: "#fff" },
    secondary: { main: "#475569" },
    background: { default: "#eceef3" },
  },
  shape: { borderRadius: 4 },
  typography: {
    fontFamily: '"IBM Plex Sans", system-ui, sans-serif',
    button: { fontWeight: 600 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#eef0f6",
          color: "#4a5078",
          fontWeight: 700,
        },
      },
    },
  },
});
